import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { LogLevel } from '@sentry/types'
import App from './App.vue'
import router from './router'
import LogRocketUtil from '@/util/logrocket'
import store from './store'
import i18n from './i18n'
import { name, version } from '../package.json'
import { isDevMode, Analytics } from './util/env'

window.console.info(`🧠 ${name}: v${version} on '${process.env.VUE_APP_STAGE}'`)

Vue.config.productionTip = false

interface EventNT extends Sentry.Event {
  email?: string,
  family_name?: string,
  given_name?: string,
  date_of_birth?: string
}

Analytics.init(process.env.VUE_APP_MIXPANEL_TOKEN)

if (!isDevMode) {
  LogRocketUtil.initialize(process.env.VUE_APP_EXAMS_LOGROCKET_APPID || '')

  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: process.env.VUE_APP_STAGE || process.env.NODE_ENV,
    release: `${name}@${version}`,
    logLevel: LogLevel.Error,
    beforeSend(event: EventNT) {
      if (event.user) {
        delete event.user.email
      }
      if (event.email) {
        delete event.email
      }
      if (event.family_name) {
        delete event.family_name
      }
      if (event.given_name) {
        delete event.given_name
      }
      if (event.date_of_birth) {
        delete event.date_of_birth
      }
      return event
    }
  })
}
new Vue({
  beforeCreate() {
    this.$store.dispatch('user/attemptUserRestore')
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
